package com.kanati.admin.state

enum class ThemeMode {
    Light,
    Dark,
}

data class MaterialThemePalette(
    val background: String,
    val onBackground: String,
    val surface: String,
    val onSurface: String,
    val surfaceContainerLow: String,
    val surfaceContainer: String,
    val surfaceContainerHigh: String,
    val surfaceContainerHighest: String,
    val surfaceVariant: String,
    val onSurfaceVariant: String,
    val outline: String,
    val outlineVariant: String,
    val primary: String,
    val onPrimary: String,
    val primaryContainer: String,
    val onPrimaryContainer: String,
    val secondaryContainer: String,
    val onSecondaryContainer: String,
    val tertiaryContainer: String,
    val onTertiaryContainer: String,
    val error: String,
    val onError: String,
    val errorContainer: String,
    val onErrorContainer: String,
    val surfaceTint: String,
    val shadow: String,
    val scrim: String,
)

data class ThemePack(
    val light: MaterialThemePalette,
    val dark: MaterialThemePalette,
)

interface ThemePackSource {
    fun getThemePack(): ThemePack
}

object StaticThemePackSource : ThemePackSource {
    override fun getThemePack(): ThemePack = ThemePack(
        light = MaterialThemePalette(
            background = "#f4f7fb",
            onBackground = "#0f172a",
            surface = "rgba(255, 255, 255, 0.72)",
            onSurface = "#0f172a",
            surfaceContainerLow = "rgba(255, 255, 255, 0.56)",
            surfaceContainer = "rgba(255, 255, 255, 0.76)",
            surfaceContainerHigh = "rgba(255, 255, 255, 0.88)",
            surfaceContainerHighest = "rgba(250, 252, 255, 0.96)",
            surfaceVariant = "rgba(241, 246, 255, 0.84)",
            onSurfaceVariant = "#475569",
            outline = "rgba(148, 163, 184, 0.24)",
            outlineVariant = "rgba(255, 255, 255, 0.58)",
            primary = "#2563eb",
            onPrimary = "#ffffff",
            primaryContainer = "rgba(59, 130, 246, 0.16)",
            onPrimaryContainer = "#1d4ed8",
            secondaryContainer = "rgba(129, 140, 248, 0.14)",
            onSecondaryContainer = "#3730a3",
            tertiaryContainer = "rgba(45, 212, 191, 0.14)",
            onTertiaryContainer = "#0f766e",
            error = "#b42318",
            onError = "#ffffff",
            errorContainer = "rgba(254, 226, 226, 0.94)",
            onErrorContainer = "#991b1b",
            surfaceTint = "rgba(37, 99, 235, 0.10)",
            shadow = "rgba(15, 23, 42, 0.14)",
            scrim = "rgba(255, 255, 255, 0.36)",
        ),
        dark = MaterialThemePalette(
            background = "#07111f",
            onBackground = "#e5eefc",
            surface = "rgba(9, 18, 31, 0.72)",
            onSurface = "#e2e8f0",
            surfaceContainerLow = "rgba(10, 22, 37, 0.54)",
            surfaceContainer = "rgba(11, 24, 40, 0.72)",
            surfaceContainerHigh = "rgba(14, 29, 48, 0.84)",
            surfaceContainerHighest = "rgba(18, 35, 58, 0.92)",
            surfaceVariant = "rgba(13, 29, 49, 0.82)",
            onSurfaceVariant = "#94a3b8",
            outline = "rgba(148, 163, 184, 0.22)",
            outlineVariant = "rgba(191, 219, 254, 0.10)",
            primary = "#7cc4ff",
            onPrimary = "#0f172a",
            primaryContainer = "rgba(59, 130, 246, 0.20)",
            onPrimaryContainer = "#bfdbfe",
            secondaryContainer = "rgba(129, 140, 248, 0.18)",
            onSecondaryContainer = "#dbe4ff",
            tertiaryContainer = "rgba(45, 212, 191, 0.18)",
            onTertiaryContainer = "#ccfbf1",
            error = "#ff8a80",
            onError = "#200204",
            errorContainer = "rgba(95, 24, 29, 0.82)",
            onErrorContainer = "#ffd7d4",
            surfaceTint = "rgba(125, 211, 252, 0.12)",
            shadow = "rgba(2, 6, 23, 0.52)",
            scrim = "rgba(4, 10, 18, 0.34)",
        ),
    )
}

fun ThemePack.paletteFor(mode: ThemeMode): MaterialThemePalette =
    if (mode == ThemeMode.Light) light else dark
